import browser from 'browser-detect';

export default function useBrowser() {
  return typeof window !== 'undefined' ? browser() : {};
}
